import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

export default function SimpleListItem({
  children,
  img,
  icon,
  fullline,
  disabled,
  onClick,
  compact,
}) {
  const pointer = onClick ? 'pointer' : ''
  const border = fullline ? 'bb b--black-10' : ''
  const opacity = disabled ? 'o-50' : ''

  let iconWrap
  let imageWrap

  // TO-DO: Check if the prop is a string and embed with html markup

  const content = <div className="flex-auto self-center">{children}</div>

  if (img) {
    imageWrap = (
      <div className="flex-none relative w-20 w-auto-l mb3 mb5-ns mr4 mr0-l pr5-ns">
        {img}
      </div>
    )
  }

  if (icon) {
    iconWrap = <span className="flex-end self-center">{icon}</span>
  }

  if (!fullline) {
    return (
      <li
        className={`relative w-100 flex pv3 pl4 ${pointer} ${border} ${opacity}`}
        onClick={onClick}
      >
        {imageWrap}

        <div
          className={classNames('flex-auto flex bb b--black-10', {
            'pb4 ph4 ph5-ns ph6-l': !compact,
          })}
        >
          {content}
          {iconWrap}
        </div>
      </li>
    )
  } else {
    // eslint-disable-line
    return (
      <li
        className={`relative w-100 flex pa4 ${pointer} ${border} ${opacity}`}
        onClick={onClick}
      >
        {imageWrap}
        {content}
        {iconWrap}
      </li>
    )
  }
}

SimpleListItem.propTypes = {
  img: PropTypes.node || PropTypes.string,
  icon: PropTypes.node || PropTypes.string,
  fullline: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  compact: PropTypes.bool,
}

SimpleListItem.defaultProps = {
  compact: false,
}
